import { render, staticRenderFns } from "./YearList.vue?vue&type=template&id=55fb0633&"
import script from "./YearList.vue?vue&type=script&lang=js&"
export * from "./YearList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports